export type ContinueActionPresentation = 'active' | 'loading' | 'done';

export interface ContinueActionPresentationInput {
  loading: boolean;
  done: boolean;
  clickedThisMount: boolean;
  isLast?: boolean;
  selected: boolean;
}

/** Keep a fresh request visibly in flight, then restore the completed
 * checkmark from its persisted action click after a remount or refresh. */
export const continueActionPresentation = ({
  loading,
  done,
  clickedThisMount,
  isLast,
  selected,
}: ContinueActionPresentationInput): ContinueActionPresentation => {
  if (loading || (done && clickedThisMount && isLast)) return 'loading';
  // A failed resume clears loading without setting done. Keep the same mounted
  // control retryable even though its optimistic click remains in the store.
  if (clickedThisMount && !done) return 'active';
  if (done || selected) return 'done';

  return 'active';
};
